import styled from '@emotion/styled';
import { TextareaAutosize, Typography } from '@material-ui/core';
import { DateTimePicker } from '@material-ui/pickers';

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4px auto;
  width: 100%;

  .MuiAutocomplete-inputRoot {
    padding-top: 3.8px !important;
    padding-bottom: 3.8px !important;
  }

  .MuiIconButton-label > .MuiSvgIcon-root {
    right: 0 !important;
    color: #333 !important;
  }

  input::placeholder {
    color: #333 !important;
    opacity: 1 !important;
  }

  .MuiInputBase-input.Mui-disabled {
    background-color: rgba(239, 239, 239, 0.3);
  }

  textarea:disabled {
    background-color: rgb(250 250 250);

    &:hover:not(:focus) {
      border-color: rgba(0, 0, 0, 0.23);
    }
  }
`;

export const InputDateDiv = styled.div(
  ({ width }: { width?: string }) => `
  display: flex;
  flex-direction: column;
  margin: 4px 0;
  ${width ? `width: ${width};` : 'width: 70%;'}

  .MuiAutocomplete-inputRoot {
    padding-top: 3.8px !important;
    padding-bottom: 3.8px !important;
  }

  .MuiSvgIcon-root {
    right: 0 !important;
    color: #555;
  }

  input {
    padding: 4.5px 4.5px 4.5px 6px;
  }

  input::placeholder {
    color: #333 !important;
    opacity: 1 !important;
  }
`,
);

export const CustomTypography = styled(Typography)<{ taxonomy?: string }>`
  margin: 6px 0 !important;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  opacity: 0.8;

  ${({ taxonomy }): string =>
    taxonomy === 'true'
      ? `
    & > *:nth-of-type(even) {
      color: #00a4e4;
      font-weight: bold;
    }
  `
      : ''}
`;

export const CustomEndAdornment = styled.div`
  position: absolute;
  right: 12px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > p {
    cursor: pointer;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  margin-top: 24px;
  button {
    flex-grow: 1;
    margin: 0 10px;
  }
  button:first-of-type {
    margin-left: 0px;
    margin-right: 10px;
  }
  button:last-child {
    margin-right: 0px;
    margin-left: 10px;
  }
  button:only-child {
    margin: 0;
  }
`;

export const CustomTextAreaAutosize = styled(TextareaAutosize)<{ error?: number }>`
  margin: 0 0 4px 0;
  resize: none;
  padding: 10.5px 14px;
  color: rgb(83, 97, 113);
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 16px;

  &:focus {
    outline: 1px solid ${(props): string => (props.error ? 'red' : '#536171')} !important;
    border-color: ${(props): string => (props.error ? 'red' : '#536171')};
  }

  border-color: ${(props): string => (props.error ? 'red' : 'rgba(0, 0, 0, 0.23)')};

  &:hover:not(:focus) {
    border-color: ${(props): string => (props.error ? 'red' : '#536171')};
  }
`;

export const StyledDatepicker = styled(DateTimePicker)`
  & .MuiPickersCalendarHeader-dayLabel {
    color: #2e3844 !important;
  }
  & .MuiPickersDay-daySelected {
    background-color: #00a4e4;
  }
`;
